export const CONTRATO_VERSAO_CONTRATO = 1;
export const CONTRATO_VERSAO_ADITIVO = 2;
export const CONTRATO_VERSAO_DISTRATO = 3;

export const allContratoVersoes = [
  CONTRATO_VERSAO_CONTRATO,
  CONTRATO_VERSAO_ADITIVO,
  CONTRATO_VERSAO_DISTRATO,
];

export const CONTRATO_VERSAO_CONTRATO_NAME = 'contrato';
export const CONTRATO_VERSAO_ADITIVO_NAME = 'aditivo';
export const CONTRATO_VERSAO_DISTRATO_NAME = 'distrato';

export const allContratoTipoNomes = [
  CONTRATO_VERSAO_CONTRATO_NAME,
  CONTRATO_VERSAO_ADITIVO_NAME,
  CONTRATO_VERSAO_DISTRATO_NAME,
];
